
import createRandomString from '../../../libs/utils/createRandomString'

interface CreateFileTransferExtraParamsInput {
  chash: string;
  fileTransferSessionId: string;
  nickname: string;
  connectionId: string;
  clientTimestamp?: string | number;
}

export interface CreateFileTransferExtraParamsOutput {
  actionUrl: string;
  nickname: string;
  progressSubmitParams: {
    chash: string;
    fileTransferId: string;
    fileTransferSessionId: string;
    cmdUrl: string;
  };
}

const LENGTH_FILE_TRANSFER_ID = 12;

const createFileTransferExtraParams = ({ chash, fileTransferSessionId, nickname, connectionId, clientTimestamp }: CreateFileTransferExtraParamsInput): CreateFileTransferExtraParamsOutput => {
  const fileTransferId = createRandomString(LENGTH_FILE_TRANSFER_ID);
  const cmdUrl = window.room_cmdUrl || `https://cw5i.${window.subdomainsExceptFirst}`;
  // window.room_cmdUrl
  const actionUrl = `${cmdUrl}/file-transfer/upload/${chash}/${fileTransferSessionId
  }?ftid=${fileTransferId}&connectionId=${connectionId}&clientTimestamp=${clientTimestamp}`;

  return {
    actionUrl,
    nickname,
    progressSubmitParams: {
      chash,
      fileTransferId,
      fileTransferSessionId,
      cmdUrl,
    },
  };
};

export default createFileTransferExtraParams;
